import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  calculatedViewMode,
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { REGION_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { loadSZLTList } from '../../../RegionRegistry/actions';
import { additionalSzltColumns, szltColumns } from '../../../RegionRegistry/components/szltColumns';
import { getRegisterData } from '../../../RegionRegistry/reducer';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import { REGISTRIES_STATUS_LIST } from '../../../../configs';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import ApplicationsDTO from '../../../../dto/ApplicationsDTO';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';

export function OrderServiceBox(props) {
  const { onClose = () => {}, currentApplicant = {} } = props;
  const dispatch = useDispatch();
  const {
    szltList,
    szltListMeta,
    loadingSzltList,
  } = useSelector(getRegisterData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();
  const filterName = 'applicant-order-service-list';
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].szltListMeta, opts);
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: {
        ...filterData,
        ...viewModeData,
        applicant_id: currentApplicant?.id,
      },
      sort,
    };
    const p1 = dispatch(loadSZLTList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const { updatePeriod } = useSelector(getSystemData);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const [sort, setSort] = useState(getDefaultSort(szltColumns));

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  const handleOpenTab = item => {
    window.open(`/region-registry/szlt?registry_id=${item?.id}`, '_blank');
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="applicant-body flex-column">
      <TimerLoader loading={loadingSzltList} />
      <div className="applicant-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'applicant.card.menu.service' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            placeholder="Статус"
            options={REGISTRIES_STATUS_LIST}
            addPlaceholder
            multiple
          />
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.SZLT}
              />
            )
            : null}
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={szltList}
            columns={szltColumns}
            onDoubleClickByRow={item => handleOpenTab(item)}
            additionalColumns={additionalSzltColumns}
            name="service-grid"
            changeSort={changeSort}
            sort={sort}
            settingsFormatter={moreFormatter}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={szltListMeta} list={szltList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
